/** @module csi/widget/_svg/PaperSize */
define([
	"dojo/_base/lang",
	"dijit/_WidgetBase",
	"dijit/_TemplatedMixin",
	"csi/locale",
	"csi/xml",
	"./_Plugin",
	"./PluginFactory"
], function(lang,_WidgetBase,_TemplatedMixin,locale,xml,_Plugin,PluginFactory) {

	return PluginFactory.declare([_WidgetBase, _TemplatedMixin, _Plugin], {
		templateString: '<span class="dijitInline csi-canvas-paper-size">${ViewPreferences_PaperSize:_nls}: <span data-dojo-attach-point="labelNode"></span></span>',
		pluginName: "paperSize",
		
		_setLabelAttr: {node: "labelNode", type: "innerText"},
		
		/**
		 * Always show paper size
		 */
		canShowPlugin: function() {
			return true;
		},
		
		/**
		 * Initialize label and watch for changes to paper size
		 */
		postCreate: function() {
			this.inherited(arguments);
			this._updatePaperSize();
			this.editor.view.watch("printPaper", lang.hitch(this, this._updatePaperSize));
		},
		
		/**
		 * Update label based on paper size
		 */
		_updatePaperSize: function() {
			this.set("label", locale.getEnumName(xml.enumCreate("PaperSize", this.editor.view.getPrintPaper())));
		}
	});
});